
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Color, NgxChartsModule, ScaleType } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-redeem-dashboard',
  standalone: true,
  imports: [CommonModule,FormsModule,NgxChartsModule],
  templateUrl: './redeem-dashboard.component.html',
  styleUrl: './redeem-dashboard.component.css'
})
export class RedeemDashboardComponent {
  tabs = ['Cash And Partner Redeem', 'Seller Redeem', 'Seller Redeem Points'];
  activeTab = 'Seller Redeem'; // Default active tab
  view: string = 'grid';
  // Function to set the active tab
  setActiveTab(tab: string): void {
    this.activeTab = tab;
     // Default view


    if (tab === 'Cash And Partner Redeem') {
      this.view = 'grid';  // Default to 'grid' view for Total Revenue
    } else if (tab === 'Seller Redeem Points') {
      this.view = 'grid';  // Default to 'grid' view for Monthly Revenue as well
    }
  }

    // Function to switch views
    setView(view: string): void {
      this.view = view;
    }

    // Function to refresh data
    refreshData(): void {
      console.log('Data refreshed!');
      // Add your logic for refreshing data here
    }

  onDropdownSelection(event: Event): void {
    const target = event.target as HTMLSelectElement; // Type-casting the event target to HTMLSelectElement
    const option = target.value;

    switch (option) {
      case 'grid':
        this.setView('grid');
        break;
      case 'chart':
        this.setView('chart');
        break;
      case 'refresh':
        this.refreshData();
        break;
      default:
        console.log('Unknown option selected:', option);
    }
  }

  chartData = [
    {
      name: 'Total Amount Allocated to Seller',
      value: 362798.26,
    },
    {
      name: 'Total Redeemed Amount',
      value: 56180.09,
    },
    {
      name: 'Total Unredeemed Amount',
      value: 306618.17,
    },
  ];

  chartOptions = {
    showXAxisLabel: true,
    showYAxisLabel: true,
    showGridLines: true,

    // Increase space for labels by rotating them
    xAxisTickFormatting: (tick: string) => tick,
    labelTrim: false, // Ensure labels are not trimmed
    animations: true, // Enable animations
    // Adjust tick angle for better visibility
    xAxisTickRotate: 45, // Rotate the labels to avoid truncation
    // Optional: Increase margin if labels are still cut off
    margin: [20, 30, 30, 40], // Top, Right, Bottom, Left margins
  };

  colorScheme: Color = {
    name: 'custom',
    selectable: true,
    group: ScaleType.Ordinal, // Corrected to use ScaleType.Ordinal
    domain: ['#5AA454', '#A10D2E', '#C7B42C', '#AAAAAA']  // Example colors
  };

  rotateXAxisLabels(tick: string): string {
    // Return formatted label or rotate tick based on your need
    return tick;
  }

  tableData = [
    {
      // amount: '6950',
      id: 1,
      type: 'Total Amount Allocated to Seller',
      totalAmount: 'SAR 362798.26',
    },
    {
      // amount: '4850',
      id: 2,
      type: 'Total Redeemed Amount',
      totalAmount: 'SAR 56180.09',
    },
    {
      amount: '9100',
      id: 3,
      type: 'Total Unredeemed Amount',
      totalAmount: 'SAR 306618.17',
    },
  ];



  chartData2 = [
    {
      name: 'Total Points Allocated to Seller',
      value: 7255965,
    },
    {
      name: 'Total Redeemed Points',
      value: 1123601,
    },
    {
      name: 'Total Unredeemed Points',
      value: 6132363,
    },
  ];

  chartOptions2 = {
    showXAxisLabel: true,
    showYAxisLabel: true,
    showGridLines: true,
    xAxisLabel: 'Revenue Types',
    yAxisLabel: 'Amount (SAR)',
    // Increase space for labels by rotating them
    xAxisTickFormatting: (tick: string) => tick,
    labelTrim: false, // Ensure labels are not trimmed
    animations: true, // Enable animations
    // Adjust tick angle for better visibility
    xAxisTickRotate: 45, // Rotate the labels to avoid truncation
    // Optional: Increase margin if labels are still cut off
    margin: [20, 30, 30, 40], // Top, Right, Bottom, Left margins
  };

  colorScheme2: Color = {
    name: 'custom',
    selectable: true,
    group: ScaleType.Ordinal, // Corrected to use ScaleType.Ordinal
    domain: ['#5AA454', '#A10D2E', '#C7B42C', '#AAAAAA']  // Example colors
  };

  rotateXAxisLabel2(tick: string): string {
    // Return formatted label or rotate tick based on your need
    return tick;
  }

  tableData2 = [
    {
      // amount: '6950',
      id: 1,
      type: 'Total Points Allocated to Seller',
      totalAmount: 'SAR 7255965',
    },
    {
      // amount: '4850',
      id: 2,
      type: 'Total Redeemed Points',
      totalAmount: 'SAR 1123601',
    },
    {
      // amount: '9100',
      id: 3,
      type: 'Total Unredeemed Points',
      totalAmount: 'SAR 6132363',
    },
  ];



}
